// utils/request.js
import axios from "axios";
import { Toast, Dialog } from "vant";
// 创建 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API || "/api", // 从 .env 文件读取
  timeout: 180000, // 10秒超时
});
const skipLoadingUrls = [
  "/voice-upload/fileUploadInit",
  "/voice-upload/fileUploadAuth",
  "/voice-upload/fileUploadMulti",
  // 可以加更多不需要 loading 的接口
];

// 判断当前请求 URL 是否在白名单中
// 请求拦截器
service.interceptors.request.use(
  (config) => {
    const shouldSkip = skipLoadingUrls.some((url) => config.url.includes(url));
    // 如果配置了 skipLoading，则跳过自动显示 loading
    if (!config.skipLoading && !shouldSkip) {
      // 显示加载提示（可选）
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0, // 持续显示，直到关闭
      });
    }

    const token = sessionStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `${token}`;
    }

    if (!config.headers["Content-Type"] && !config.headers["content-type"]) {
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }

    return config;
  },
  (error) => {
    Toast.clear();
    return Promise.reject(error);
  },
);

// 响应拦截器
service.interceptors.response.use(
  (response) => {
    const shouldSkip = skipLoadingUrls.some((url) =>
      response.config.url.includes(url),
    );
    if (!shouldSkip) {
      Toast.clear(); // 关闭 loading
    }
    // 判断是否为文件流类型响应
    const contentType = response.headers["content-type"];
    if (
      contentType &&
      (contentType.includes("application/octet-stream") ||
        contentType.includes("application/vnd.ms-excel") ||
        contentType.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        ) ||
        contentType.includes("application/pdf") ||
        contentType.includes("application/zip") ||
        contentType.includes("application/x-zip-compressed") ||
        contentType.includes("video/mp4") ||
        contentType.includes("video/webm"))
    ) {
      // 文件流类型，直接返回响应
      return response;
    }
    const res = response.data;

    // 根据后端约定判断是否成功（假设 code === 200 表示成功）
    if (res.code === 0 || res.code == 200) {
      return res.data; // 直接返回业务数据
    } else {
      // 业务错误（如 token 过期、参数错误）
      Toast.fail(res.msg || "请求失败");
      return Promise.reject(new Error(res.msg || "Error"));
    }
  },
  (error) => {
    Toast.clear();

    let message = "网络异常，请稍后重试";
    if (error.response) {
      const status = error.response.status;
      if (status === 401) {
        message = "登录已过期，请重新登录";
        // 可跳转登录页
        // router.push('/login')
      } else if (status === 403) {
        message = "权限不足";
      } else if (status === 500) {
        message = "服务器内部错误";
      }
    }

    Toast.fail(message);
    return Promise.reject(error);
  },
);

export default service;
